module.exports = __webpack_public_path__ + "img/doctors.d01efa12.png";